export const normalizeSubscriptionStatus = (status) =>
  String(status || "").trim().toLowerCase();

export const isSubscriptionActive = (status) =>
  normalizeSubscriptionStatus(status) === "active";

export const isSubscriptionCancelling = (status) =>
  normalizeSubscriptionStatus(status) === "cancelling";

export const isSubscriptionPastDue = (status) =>
  normalizeSubscriptionStatus(status) === "past_due";

/** Blocks main app routes; past_due still has access (billing warning lives in settings). */
export const isSubscriptionAccessBlocked = (status) => {
  const normalizedStatus = normalizeSubscriptionStatus(status);
  return ["inactive", "cancelled", "canceled", "unpaid"].includes(
    normalizedStatus
  );
};
